import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="lazy-form"
export default class extends Controller {
  static targets = ["button"];

  submit(event) {
    const button = this.buttonTarget;

    // Preserve the button's current width and height
    const buttonWidth = button.offsetWidth + "px";
    const buttonHeight = button.offsetHeight + "px";
    button.style.width = buttonWidth;
    button.style.height = buttonHeight;

    // Change the button text and disable it
    button.innerHTML = '<span class="small-loader"></span>';
    button.disabled = true;
  }
}